"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = exports["default"] = function _default(condition) {
  var knownConditions = {
    all_respondents: 'All Respondents',
    complete: 'Completed',
    incomplete: 'Partially Completed',
    incomplete_or_not_started: 'Partially Completed or Not Started',
    not_started: 'Not Started',
    on_respondent_complete: 'On Respondent Complete',
    on_respondent_complete_notify: 'On Respondent Complete',
    on_respondent_complete_module: 'On Respondent Completion of a Module',
    on_respondent_complete_module_notify: 'On Respondent Completion of a Module',
    on_respondent_complete_survey: 'On Respondent Completion of a Survey',
    on_respondent_complete_survey_notify: 'On Respondent Completion of a Survey',
    on_respondent_rostered: 'On Respondent Rostered',
    scheduled: 'Scheduled',
    scheduled_on_respondent_complete: 'On Respondent Complete (Schedule Offset)',
    scheduled_on_respondent_complete_notify: 'On Respondent Complete (Schedule Offset)',
    scheduled_on_respondent_complete_module: 'On Respondent Completion of a Module (Schedule Offset)',
    scheduled_on_respondent_complete_module_notify: 'On Respondent Completion of a Module (Schedule Offset)',
    scheduled_on_respondent_complete_survey: 'On Respondent Completion of a Survey (Schedule Offset)',
    scheduled_on_respondent_complete_survey_notify: 'On Respondent Completion of a Survey (Schedule Offset)',
    scheduled_on_respondent_rostered: 'On Respondent Rostered (Schedule Offset)',
    scheduled_target_met: 'Target Met (Schedule Offset)',
    target_met: 'Target Met',
    target_not_met: 'Target Not Met'
  };
  return knownConditions[condition] || condition;
};